import _ from "lodash";
import React from "react";
import { Input, Button, Tabs } from "antd";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  setApiConfig,
  setDataThunk,
  setNotification,
} from "../../services/store";

const ApiPanel = () => {
  const [loading, setLoading] = React.useState(false);
  const [response, setResponse] = React.useState(null);
  const [postData, setPostData] = React.useState({});
  const [activeTab, setActiveTab] = React.useState("request");
  const dispatch = useDispatch();
  const { apiConfig = {} } = useSelector((state) => state.grid);
  const request = `${apiConfig.endpoint}${
    apiConfig.queryString ? `?${apiConfig.queryString}` : ""
  }`;

  const fetchData = async (withCursor = false) => {
    setLoading(true);
    const params = Object.fromEntries(
      new URLSearchParams(apiConfig.queryString),
    );
    if (withCursor) {
      params.cursor = apiConfig.cursor;
    }

    try {
      const response = await axios.get(apiConfig.endpoint, {
        params,
      });
      const data = _.get(response, apiConfig.responseObj);
      setResponse(data);
      const title = _.get(data, apiConfig.titleMapping, "");
      const content = _.get(data, apiConfig.contentMapping, "");
      const cursor = _.get(data, apiConfig.cursorMapping, "");

      const post = { title, content };
      setPostData(post);
      dispatch(setApiConfig({ cursor }));
      dispatch(setDataThunk(post));
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(
        setNotification({
          type: "error",
          message: "Error fetching data",
          description: error.message,
        }),
      );
      setResponse({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  const config = [
    {
      key: "endpoint",
      label: "API Endpoint",
      placeholder: "https://api.example.com/data",
    },
    {
      key: "queryString",
      label: "Query String",
      placeholder: "userId=1&cursor=100",
    },
    {
      key: "cursor",
      label: "Cursor",
    },
    {
      key: "responseObj",
      label: "Response Object",
    },
    {
      key: "titleMapping",
      label: "Mapping (Title)",
    },
    {
      key: "contentMapping",
      label: "Mapping (Content)",
    },
    {
      key: "cursorMapping",
      label: "Mapping (Cursor)",
    },
  ];

  const tabItems = [
    {
      key: "request",
      label: "Request",
      children: (
        <div className="p-2 border bg-white rounded-lg">
          <div className="text-xs break-all overflow-hidden text-black">
            {request || "-"}
          </div>
        </div>
      ),
    },
    {
      key: "response",
      label: "Response",
      children: (
        <div className="p-2 border bg-white rounded-lg">
          <pre className="bg-transparent p-0 m-0 text-xs overflow-auto">
            {JSON.stringify(response, null, 1)}
          </pre>
        </div>
      ),
    },
    {
      key: "content",
      label: "Content",
      children: (
        <div className="p-2 border bg-white rounded-lg">
          <pre className="bg-transparent p-0 m-0 text-xs overflow-auto">
            {JSON.stringify(postData, null, 1)}
          </pre>
        </div>
      ),
    },
  ];

  return (
    <div>
      {config.map(({ key, label, placeholder }) => (
        <div className="flex flex-col items-start gap-1 mb-3" key={key}>
          <label className="text-xs font-bold">{label}</label>
          <Input
            placeholder={placeholder || key}
            value={apiConfig[key]}
            onChange={(e) => dispatch(setApiConfig({ [key]: e.target.value }))}
            spellCheck={false}
          />
        </div>
      ))}
      <div className="flex gap-2">
        <Button disabled={loading} loading={loading} onClick={fetchData}>
          Fetch
        </Button>
        <Button
          disabled={loading}
          loading={loading}
          onClick={() => fetchData(true)}
        >
          Next
        </Button>
      </div>
      <hr className="my-2" />
      <Tabs
        onChange={(value) => setActiveTab(value)}
        type="card"
        activeKey={activeTab}
        items={tabItems}
        size="small"
      />
    </div>
  );
};

export default ApiPanel;
